import Vue from 'vue';
import App from './app.vue';

window.Vue = Vue;

// mount
new Vue({
    
    el: '#calendar-app',
    data: {
        
    },
    render: (h) => h(App, {
        
    }),
    computed: {
        isMobile: function () {
            return window.matchMedia("only screen and (max-width: 760px)").matches;
        }
    }

})


// WEBPACK FOOTER //
// ./ClientApp/calendar/boot.js